export default "__VITE_ASSET__ShlJtb9n__"